import { Entity } from '@data-client/rest';
import { ISODate } from '../utils/transforms';
class OrganizationRoleEntity extends Entity {
    constructor() {
        super(...arguments);
        this.cloneFromId = null;
        this.creationDTTM = new Date(0);
        this.description = null;
        this.isCloneFromDefault = false;
        this.isDefault = false;
        this.isEnabled = false;
        this.name = null;
        this.organizationRoleId = 0;
    }
    pk() {
        return this.organizationRoleId.toString();
    }
}
OrganizationRoleEntity.schema = {
    creationDTTM: ISODate
};
OrganizationRoleEntity.key = 'OrganizationRole';
export { OrganizationRoleEntity };
